import { useEffect } from "react";

const useClickOutside = (ref: React.RefObject<HTMLElement>, callback: () => void, stepsEnabled: boolean): void => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (event.target instanceof Element) {
        // A control that removes itself (a Back button swapping the step) is detached by the
        // time the click reaches the document, so `contains` would wrongly call it outside.
        if (!event.target.isConnected) return;

        const isRadioWrapper = event.target.classList.contains("MuiSvgIcon-root");
        const retryButton = event.target.classList.contains("retry-button");
        let isAddItemButton = false;
        let currentElement: Element | null = event.target;

        // Traverse up the DOM tree to check if any ancestor has the 'add-item-button' class
        while (currentElement) {
          if (currentElement.classList.contains("add-item-button")) {
            isAddItemButton = true;
            break;
          }
          currentElement = currentElement.parentElement;
        }

        if (isRadioWrapper || retryButton || isAddItemButton) {
          return;
        }

        if (ref.current && !ref.current.contains(event.target)) {
          callback();
        }
      }
    };

    if (!stepsEnabled) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [ref, callback, stepsEnabled]);
};

export default useClickOutside;
